import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DownloadSimple, FileText, ShoppingBag } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { AppHead } from "@/pages/app/Dashboard";
import { useT } from "@/i18n";

export default function MyTemplates() {
  const { t, lang } = useT();
  const [files, setFiles] = useState(null);
  useEffect(() => { api.get("/me/templates").then((r) => setFiles(r.data)).catch(() => setFiles([])); }, [lang]);
  return (
    <div data-testid="my-templates-page">
      <AppHead title="My templates" sub="Everything you bought with this email. Download as often as you like." />
      {files === null && <div className="skeleton h-24 max-w-xl" />}
      {files?.length === 0 && (
        <div className="card p-8 bg-white max-w-xl" data-testid="my-templates-empty">
          <p className="text-gray-700">{t("No templates yet. Purchases made with this email appear here automatically.")}</p>
          <Link to="/templates" className="btn-coral mt-4 text-sm" data-testid="my-templates-shop-btn"><ShoppingBag size={16} /> {t("Browse templates")}</Link>
        </div>
      )}
      <div className="grid md:grid-cols-2 gap-4">
        {files?.map((f) => (
          <div key={f.file_id} className="card p-6 bg-white flex items-center justify-between gap-4" data-testid={`my-template-${f.file_id}`}>
            <div className="flex items-center gap-3"><FileText size={28} weight="duotone" className="text-[#E36414] shrink-0" /><p className="font-medium text-[#0F4C5C] min-w-0">{f.name}</p></div>
            <a href={`${process.env.REACT_APP_BACKEND_URL}${f.url}`} className="btn-teal text-sm !py-2 shrink-0" data-testid={`my-template-download-${f.file_id}`}><DownloadSimple size={16} /> {t("Download")}</a>
          </div>
        ))}
      </div>
    </div>
  );
}
